import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AuthGuard, CmsConfig, ConfigModule } from '@spartacus/core';
import { KnBrCustomerContextGuard } from 'src/app/shared/guards/kn-br-customer-context.guard';
import { SpinnerModule } from '@spartacus/storefront';
import { KnBrShipmentArrivalsComponent } from './kn-br-shipment-arrivals.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
@NgModule({
  declarations: [KnBrShipmentArrivalsComponent],
  imports: [
    CommonModule,
    SpinnerModule,
    FormsModule,
    ReactiveFormsModule,
    ConfigModule.withConfig({
      cmsComponents: {
        CarlisleShipmentArrivalsHeaderComponent: {
          component: KnBrShipmentArrivalsComponent,
          guards: [AuthGuard, KnBrCustomerContextGuard],
        },
      },
    } as CmsConfig),
  ],
})
export class KnBrShipmentArrivalsModule {}
